import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth='lg'>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant='body2' color='text.secondary'>
            © {new Date().getFullYear()} Ficohsa Seguros. Todos los derechos reservados.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link href='#' color='text.secondary' underline='hover' variant='body2'>
              Términos y Condiciones
            </Link>
            <Link href='#' color='text.secondary' underline='hover' variant='body2'>
              Política de Privacidad
            </Link>
            <Link href='#' color='text.secondary' underline='hover' variant='body2'>
              Contacto
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
